// Klíče react-query zakázek a Můj den — malý soubor bez dotazů, aby je mohla vrstva offline a Domů importovat, aniž by se
// do hlavního balíku táhl celý `api/zakazky.ts` (rozpočet hlavního balíku, vite.config.ts). `api/zakazky.ts` je
// z tohoto souboru znovu vyváží, takže ostatní importy zůstávají beze změny.

export const KLIC_MUJ_DEN = ['muj-den'] as const;
export const KLIC_ZAKAZKY = ['zakazky'] as const;
export const klicZakazky = (id: string) => [...KLIC_ZAKAZKY, 'karta', id] as const;
export const klicPolozekZakazky = (id: string) => [...KLIC_ZAKAZKY, 'polozky', id] as const;
